<template>
    <div >
        <v-expansion-panels class="container" flat :mandatory = isShow  >
        <v-expansion-panel  >
            <v-expansion-panel-header  @click="openPanel" color="#F7F7F7">
            <h2>{{nameOfDepartment}}</h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content  color="#F7F7F7">
                <div>
                <human :model="model"  />
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import human from '../contentComponents/ContentType.Human.vue'

export default {
  name: 'departament',
  props: ['model'],
  components: {
    human
  },
  computed: {
    nameOfDepartment: function () {
      return this.model[0].departmentName
    }
  },
  data: () => ({
    isShow: true
  }),
  methods: {
    openPanel() {
      this.isShow = !this.isShow
    }
  }

}
</script>
<style lang="scss" scoped>
.container {
  width: 80%;
}

</style>
